'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

//const FALLBACK_IMAGE = '/image/no-image.png';
const FALLBACK_IMAGE = '/images/no_image_square.svg';

const normalizeImageSrc = (src: ImageProps['src']) => {
  // StaticImport (import img from ...)
  if (typeof src !== 'string') return src;

  if (src.startsWith('blob:')) return src;
  if (src.startsWith('http')) return src;
  if (src.startsWith('/')) return src;

  return `/${src}`;
};

const ImageOptimizer = (props: ImageProps) => {
  const [hasError, setHasError] = useState(false);

  const src = hasError ? FALLBACK_IMAGE : normalizeImageSrc(props.src);
  const isBlobUrl = typeof src === 'string' && src.startsWith('blob:');

  return (
    <Image
      {...props}
      src={src}
      alt={props.alt || '이미지 없음'}
      loading={props.priority ? undefined : (props.loading ?? 'lazy')}
      unoptimized={isBlobUrl || props.unoptimized}
      onError={() => setHasError(true)}
    />
  );
};

export default ImageOptimizer;
